export default class ClientConstants 
{
    public static  IDENTITY = "https://api.flyx2.cloud/identity";
    public static  CLIENT_PRIMARY_COLOR = "#94A596";
    public static  CLIENT_NAME = "Breakpoint";
    public static  CLIENT_IMAGE = "https://shuttle-storage.s3.amazonaws.com/breakpointnew/system/resized/OG-Image_1200x1200.jpg?1600261414";
    public static ROUND_CLIENT_IMAGE = true;
}